import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createFronteggStore } from '@frontegg/redux-store';
import { Metadata } from '@frontegg/types';
import { FronteggApp } from '../FronteggApp';
import { waitThemeSetter } from '../utils';
var defaultTheme = 'modern';
export { defaultTheme };
export var getThemeByName = function getThemeByName(name) {
  var _name;

  // Load themes from window chunk to support cdn getThemeByName
  var themes = window['FronteggAdminPortal'].themes;
  return (_name = themes[name]) != null ? _name : themes[defaultTheme];
};
export var LoginBoxRenderer = /*#__PURE__*/function () {
  function LoginBoxRenderer(name, themeOptions, store, appOptions) {
    _classCallCheck(this, LoginBoxRenderer);

    this.app = void 0;
    this.options = void 0;
    this.store = void 0;
    this.themeSetter = void 0;

    this.setRoute = function () {};

    this.themeOptions = {};
    var contextOptions = {
      baseUrl: 'preview'
    };
    this.store = store != null ? store : createFronteggStore({
      context: contextOptions
    }, this, true, undefined, undefined, true);
    this.options = _extends({
      themeOptions: themeOptions,
      iframeRendering: true,
      metadata: {},
      previewMode: true,
      builderMode: true,
      store: this.store,
      contextOptions: contextOptions,
      onRedirectTo: function onRedirectTo() {
        console.debug('path');
      }
    }, appOptions);
    this.app = new FronteggApp(this.options, name, true);
    Metadata.set({}, name);
  }

  _createClass(LoginBoxRenderer, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(loginBoxContainer) {
        var _this = this;

        var loginBoxEl, setThemeSetter, setStaticRouteSetter, FronteggLoginBox;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loginBoxEl = loginBoxContainer.querySelector('#root');

                if (!loginBoxEl) {
                  loginBoxEl = loginBoxContainer.ownerDocument.createElement('div');
                  loginBoxEl.setAttribute('id', 'root');
                  loginBoxContainer.appendChild(loginBoxEl);
                }

                this.app.loginBoxContainer = loginBoxContainer;
                this.app.loginBoxEl = loginBoxEl;

                setThemeSetter = function setThemeSetter(themeSetter) {
                  _this.themeSetter = themeSetter;
                };

                setStaticRouteSetter = function setStaticRouteSetter(setStaticRoute) {
                  _this.setRoute = setStaticRoute;
                };

                _context.next = 8;
                return this.app.loadScript('FronteggLoginBox');

              case 8:
                FronteggLoginBox = _context.sent;
                this.app.loginBoxRenderer = FronteggLoginBox.renderPage(loginBoxEl, {
                  options: this.options,
                  injector: this.app,
                  setThemeSetter: setThemeSetter,
                  setStaticRouteSetter: setStaticRouteSetter,
                  staticRoute: '/account/login'
                });
                _context.next = 12;
                return waitThemeSetter(this);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function render(_x) {
        return _render.apply(this, arguments);
      }

      return render;
    }()
  }, {
    key: "unmount",
    value: function unmount() {
      try {
        var _this$app$loginBoxRen;

        (_this$app$loginBoxRen = this.app.loginBoxRenderer) == null ? void 0 : _this$app$loginBoxRen.unmount();
      } catch (e) {
        console.error('Failed to unmount login box renderer', e);
      }
    }
  }, {
    key: "setTheme",
    value: function setTheme(themeOptions) {
      var _this$themeSetter;

      this.themeOptions = themeOptions;

      if (!this.themeSetter) {
        console.warn('this.themeSetter is not defined yet');
      }

      (_this$themeSetter = this.themeSetter) == null ? void 0 : _this$themeSetter.call(this, this.themeOptions);
    }
  }, {
    key: "setStaticRoute",
    value: function setStaticRoute(staticRoute) {
      var _this$setRoute;

      if (!this.setRoute) {
        console.warn('this.setRoute is not defined yet');
      }

      (_this$setRoute = this.setRoute) == null ? void 0 : _this$setRoute.call(this, staticRoute);
    }
  }, {
    key: "setStore",
    value: function setStore(state) {
      this.store.dispatch({
        type: 'auth/setState',
        payload: state
      });
    }
  }]);

  return LoginBoxRenderer;
}();
export default LoginBoxRenderer;